import styled from '@emotion/styled';
import {Position} from '@models/ReactTypes';
import {a, useSpring, useSpringRef, useTransition} from 'react-spring';

const Wrapper = styled.div<{ bold?: boolean }>`
  position: relative;
  display: inline-flex;
  min-width: 8px;
  font-weight: ${(props) => (props.bold === true ? (props) => props.theme.weights.bold : (props) => props.theme.weights.regular)};
`;

const NumberContainer = styled.div`
  transform-origin: left left;
`;

const AnimatedNumber = a(NumberContainer);

const Percentage = styled.div`
  transform-origin: center center;
  width: 12px;
`;

const AnimatedPercent = a(Percentage);

interface Props {
  content: string;
  loading: boolean;
  bold?: boolean;
}

export const AnimatedPercentage = (props: Props) => {
  const contentAnimRef = useSpringRef();
  const contentTransition = useTransition(props.loading ? [] : props.content, {
    from: { position: 'absolute' as Position, opacity: 0, scaleX: 0 },
    enter: { position: 'relative' as Position, opacity: 1, scaleX: 1 },
    leave: { position: 'absolute' as Position, opacity: 0, scaleX: 1 },
  });

  const percentAnim = useSpring({
    from: { rotate: '0deg' },
    to: props.loading ? { rotate: '180deg' } : { rotate: '0deg' },
    loop: () => (props.loading ? true : false),
  });

  return (
    <Wrapper bold={props.bold}>
      {contentTransition((style, item) => (
        <AnimatedNumber style={style}>{item}</AnimatedNumber>
      ))}
      <AnimatedPercent style={percentAnim}>%</AnimatedPercent>
    </Wrapper>
  );
};

export default AnimatedPercentage;
